export const common = {
  nav: {
    home: "Accueil",
    about: "À Propos",
    projects: "Projets",
    news: "Actualités",
    getInvolved: "S'Impliquer",
    donateNow: "Faire un Don"
  },
  footer: {
    about: {
      description: "Autonomiser les réfugiés et les communautés vulnérables en République Démocratique du Congo grâce à l'aide d'urgence, aux soins de santé, à l'éducation et au développement durable."
    },
    newsletter: {
      placeholder: "Entrez votre email"
    },
    quickLinks: {
      title: "Liens Rapides",
      home: "Accueil",
      about: "À Propos",
      projects: "Projets",
      news: "Actualités",
      getInvolved: "S'Impliquer",
      contact: "Nous Contacter"
    },
    social: {
      title: "Connectez-vous avec Nous"
    },
    copyright: "© 2024 BridgeCore empowermennt initiative. Tous droits réservés."
  },
  buttons: {
    donate: "Faire un Don",
    volunteer: "Devenir Bénévole",
    learnMore: "En Savoir Plus",
    readMore: "Lire Plus",
    viewAll: "Voir Tout"
  }
};
